import React, { useEffect, useState } from 'react'
import { Button, Card, Select } from '../../../../../common'
import 'react-toastify/dist/ReactToastify.css';
import { CommonToast } from '../../../../../common/Toast'
import { ReactComponent as InfoWarn } from '../../../../../../assets/icons/info.svg'
import { ReactComponent as ErrorWarn } from '../../../../../../assets/icons/error.svg'
import { ReactComponent as ArrowRight } from '../../../../../../assets/icons/arrowright1.svg'
import { getCurrentYear } from '../../../../../../utils/Helper';
import { useUploadFinanceDocumentMutation } from '../../../../../../store/Company/companyApiSlice'
import { useSelector } from 'react-redux'

function ShowHeadersComp({ matchedHeaders, csvHeaders, requiredCSVHeaders, headerMapping, setHeaderObject, headerObject, csvData, setIsOpen, setButtonDisabled, setFetchGraphData, fetchGraphData }) {
  const [headersChanged, setHeadersChanged] = useState(false);
  const [headerData, setHeaderData] = useState(headerMapping);
  const [uploadFinanceDocument] = useUploadFinanceDocumentMutation();
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token, userInfo } = useSelector((state) => state.auth);
  const [error, setError] = useState([])
  const [stringError, setStringError] = useState("");
  const staleData = Object.entries(headerObject)?.length > 0 ? headerObject : headerMapping;
  const handleHeaderValueChange = (e, header) => {
    staleData[header[0]] = e.target.value
    setHeaderObject(staleData)
    setHeadersChanged(!headersChanged)
    if (error?.length > 0 && e.target.value !== '') {
      handleContinue(false)
    }
  };

  function updateValueToEmpty(key, header) {
    const value = staleData[header[0]];
    if (value !== undefined && value !== "") {
      // Check if the value is already assigned to any other key
      const existingKey = Object.keys(staleData).find(k => staleData[k] === key);
      if (existingKey) {
        // Set the value to an empty string for the existing key
        staleData[existingKey] = "";
      }
    } else {
      staleData[header[0]] = key;
    }
  }

  function findDuplicateValues(obj) {
    const valueCount = {};
    const duplicateKeys = [];

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        // Check if the value has been encountered before
        if (valueCount[value]) {
          duplicateKeys.push(key, valueCount[value]);
        } else {
          // Store the key if the value is encountered for the first time
          valueCount[value] = key;
        }
      }
    }

    return duplicateKeys;
  }

  function findKeyByValue(obj, targetValue) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === targetValue) {
        return key;
      }
    }
    return null; // Return null if the value is not found
  }

  const handleContinue = async (runQuery = true) => {
    try {
      if (Object.entries(headerObject)?.length > 0) {
        headerObject.year === '' ? setError(["year"]) : setError([])
      } else {
        headerMapping.year === '' ? setError(["year"]) : setError([])
      }
      let dublicateKeys;
      let obj;
      if (Object.entries(headerObject)?.length > 0) {
        dublicateKeys = findDuplicateValues(headerObject)
        obj = headerObject;
      } else {
        dublicateKeys = findDuplicateValues(headerMapping);
        obj = headerMapping;
      }
      if (dublicateKeys?.length > 0) {
        setError(dublicateKeys)
      } else {
        const mappedData = csvData.map(item => {
          const newObj = {};
          for (const key in item) {
            const findKeyByVal = findKeyByValue(obj, key)
            if (item.hasOwnProperty(key) && findKeyByVal) {
              newObj[findKeyByVal] = item[key];
            }
          }
          return newObj;
        });
        const currentYear = getCurrentYear();
        let minYear;
        mappedData.forEach(item => {
          if (item.year === currentYear || item.year === currentYear - 1) {
            if (minYear) {
              minYear = Math.max(minYear, item.year);
            } else {
              minYear = item.year;
            }
          }
        });
        minYear ? setStringError("") : setStringError("Invalid Data");
        if (runQuery) {
          const maxYear = minYear - 5;
          const filteredData = mappedData.filter(item => item.year <= minYear && item.year > maxYear);
          const res = await uploadFinanceDocument({ data: filteredData, token: token, company_id: currentEditingCompany?.companyID }).unwrap();
          if (res.statusCode === 201) {
            CommonToast.success(res.message ?? "Something Went wrong!")
            setIsOpen(false);
            setButtonDisabled(false);
          } else {
            CommonToast.error(res.message ?? "Something Went wrong!")
          }
        }
      }
    } catch (error) {
      CommonToast.error(error ?? "Something went wrong!")
    }
  }
  useEffect(() => {
    setHeaderData(staleData);
  }, [headersChanged])

  return (
    <Card classes="rounded bg-white w-[34rem] text-left">
      <div className=''>
        <label htmlFor="companies-dropdown" className="block mb-1 text-sm text-secondarytwo font-semibold text-left pb-3">
          Company’s field mapping
        </label>
        {stringError ? <div className='w-full flex justify-start gap-2 p-2 border-[0.2px] border-red-500 text-[12px] bg-[#F5FCFF] rounded-[5px] items-center mb-3 text-red-500'><ErrorWarn /><p>{stringError}{error?.length > 0 && error[0] === 'year' ? " Year field is missing" : ""}</p> </div> : <div className='w-full flex gap-2 p-2 border-[0.2px] border-[#0077B5] text-[12px] bg-[#F5FCFF] rounded-[5px] justify-center items-center mb-3'><InfoWarn /><p>We found {matchedHeaders?.length} fields from your uploaded file. Please match them with one on ours.</p></div>}
        <div className='w-full flex items-center py-3 bg-[#EBF0F3] rounded-t-[5px] text-[13px]'>
          <div className='w-[50%] pl-2'>TREVEX Fields</div>
          <div className='w-[50%] pl-2'>CSV Fields</div>
        </div>
        <div className='max-h-[40vh] overflow-y-scroll'>
          {
            (Object.entries(Object.entries(headerObject)?.length > 0 ? headerObject : headerMapping))?.map((header, i) => (
              <div key={header + i} className='w-full flex items-center p-3 rounded-t-[5px] text-[13px]'>
                <div className='w-[50%] flex justify-between items-center'>
                  <div className='w-[80%] truncate'>{header[0]}</div>
                  <div className='w-[20%]'><ArrowRight /></div>
                </div>
                <div className='w-[50%] pl-2'>
                  <select defaultValue={header[0]} value={headerObject[header[0]]} onChange={(e) => handleHeaderValueChange(e, header)} className={`w-full border ${(error?.length > 0 && error?.find(k => k === header[0])) ? "border-red-500" : "border-input"
                    } focus:border-primary px-3 py-2 border border-input rounded bg-inputDisable outline-none text-primary`}>
                    <option value="">Select the column</option>
                    {csvHeaders?.map((column, i) => (
                      <option key={column + i}>
                        {column}
                      </option>
                    ))}
                  </select>
                  {error.length > 0 && error?.find(k => k === header[0]) && <p className="text-red-500 text-sm text-left">Verify the values</p>}
                </div>
              </div>
            ))
          }
        </div>
        <Button
          onClick={handleContinue}
          classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 align-center"
        >
          Continue
        </Button>
      </div>
    </Card>
  )
}

export default ShowHeadersComp